import * as o from "react";
import m from "./Field.mjs";
import e from "./List.mjs";
import i from "./useForm.mjs";
import t from "./Form.mjs";
import { FormProvider as s } from "./FormContext.mjs";
import "../../rc-util/es/warning.mjs";
import a from "./useWatch.mjs";
var f = /* @__PURE__ */ o.forwardRef(t), r = f;
r.FormProvider = s;
r.Field = m;
r.List = e;
r.useForm = i;
r.useWatch = a;
export {
  m as Field,
  s as FormProvider,
  e as List,
  r as default,
  i as useForm,
  a as useWatch
};
//# sourceMappingURL=index.mjs.map
